import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/BookingTrigger.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
